var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_182_1",
    "data-name": "Componente 182 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5774",
    "data-name": "Grupo 5774",
    transform: "translate(6 6.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170800",
    "data-name": "Grupo 170800"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_213",
    "data-name": "Elipse 213",
    cx: 26,
    cy: 26,
    rx: 26,
    ry: 26,
    transform: "translate(0 -0.264)",
    fill: "#ffc700"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170799",
    "data-name": "Grupo 170799",
    transform: "translate(0.415 -1.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5772",
    "data-name": "Grupo 5772",
    transform: "translate(31.822 16.217)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_215",
    "data-name": "Elipse 215",
    cx: 2.582,
    cy: 3.127,
    rx: 2.582,
    ry: 3.127,
    transform: "translate(1.545 5.87)",
    fill: "#a36200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_220",
    "data-name": "Trazado 220",
    d: "M1593.143,608.779a7.977,7.977,0,0,1,2.354-.264,9.225,9.225,0,0,1,2.249.33,10.261,10.261,0,0,1,3.915,2.1.73.73,0,0,1-.905,1.144l-.011-.008a8.667,8.667,0,0,0-3.4-1.565,7.445,7.445,0,0,0-1.839-.151,6.3,6.3,0,0,0-1.72.288l-.057.02a.992.992,0,0,1-.65-1.874Z",
    transform: "translate(-1592.41 -608.514)",
    fill: "#a36200"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_221",
    "data-name": "Trazado 221",
    d: "M1487.149,738.894c-4.053,0-7.4,2.662-7.939,6.117a.6.6,0,0,0,.772.667,20.322,20.322,0,0,1,14.334,0,.6.6,0,0,0,.772-.667C1494.553,741.556,1491.2,738.894,1487.149,738.894Z",
    transform: "translate(-1461.191 -706.771)",
    fill: "#a36200"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5773",
    "data-name": "Grupo 5773",
    transform: "translate(10.585 16.217)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_216",
    "data-name": "Elipse 216",
    cx: 2.582,
    cy: 3.127,
    rx: 2.582,
    ry: 3.127,
    transform: "translate(2.799 5.87)",
    fill: "#a36200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_222",
    "data-name": "Trazado 222",
    d: "M1426.464,610.653a6.3,6.3,0,0,0-1.72-.288,7.444,7.444,0,0,0-1.839.151,8.666,8.666,0,0,0-3.4,1.565l-.009.007a.73.73,0,0,1-.907-1.143,10.262,10.262,0,0,1,3.916-2.1,9.222,9.222,0,0,1,2.249-.33,7.978,7.978,0,0,1,2.354.264.992.992,0,1,1-.518,1.914l-.063-.019Z",
    transform: "translate(-1418.33 -608.514)",
    fill: "#a36200"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_148764",
    "data-name": "Rect\\xE1ngulo 148764",
    width: 64,
    height: 64,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.3a3015411f9ef32e1496ff4f2238bcd3.svg";
export { ForwardRef as ReactComponent };